/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options (one per line)`)
};

const es_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones (una por línea)`)
};

const de_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen (eine pro Zeile)`)
};

const nl_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opties (één per regel)`)
};

const fr_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options (une par ligne)`)
};

const it_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni (una per riga)`)
};

const pt_br2_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções (uma por linha)`)
};

const pt_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções (uma por linha)`)
};

const ja_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択肢(1行に1つ)`)
};

const zh_dw_options = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选项（每行一个）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_options = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_options(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_options", locale)
	if (locale === "en") return en_dw_options(inputs)
	if (locale === "es") return es_dw_options(inputs)
	if (locale === "de") return de_dw_options(inputs)
	if (locale === "nl") return nl_dw_options(inputs)
	if (locale === "fr") return fr_dw_options(inputs)
	if (locale === "it") return it_dw_options(inputs)
	if (locale === "pt-BR") return pt_br2_dw_options(inputs)
	if (locale === "pt") return pt_dw_options(inputs)
	if (locale === "ja") return ja_dw_options(inputs)
	return zh_dw_options(inputs)
};